module.exports = __webpack_public_path__ + "static/gallery-queen-center-1-5dc44c73e308a3fa5a77f1a1731a8c4d.jpg";